export default "__VITE_ASSET__MXcEXSBB__"